module.exports = "/_next/static/images/vidaMobile-4ae3f3753cca6ee4db32b37cf70e554b.svg";